module.exports = __webpack_public_path__ + "media/registration/male-icon-8b7cfbcc.svg";